var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "modal fade hidden-print",
        attrs: {
          id: "modal_move_materials",
          "data-name": "move_materials",
          tabindex: "-1",
          role: "dialog"
        }
      },
      [
        _c(
          "div",
          {
            staticClass: "modal-dialog modal-lg",
            staticStyle: {
              width: "100%",
              "padding-left": "15px",
              "max-width": "1550px"
            }
          },
          [
            _c(
              "div",
              { staticClass: "modal-content", staticStyle: { width: "100%" } },
              [
                _c("div", { staticClass: "modal-header" }, [
                  _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: {
                        type: "button",
                        "data-dismiss": "modal",
                        "aria-label": "Close"
                      },
                      on: {
                        click: function($event) {
                          return _vm.reset()
                        }
                      }
                    },
                    [
                      _c("span", { attrs: { "aria-hidden": "true" } }, [
                        _vm._v("×")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("h4", { staticClass: "modal-title" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.trans("warehouseman.move.title_materials")) +
                        "\n                    "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("div", { staticClass: "modal-body compact-errors" }, [
                    _c(
                      "div",
                      {
                        staticClass: "row",
                        staticStyle: { "margin-bottom": "5px" }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "col-md-6" },
                          [
                            !_vm.areCheckedShifts
                              ? _c("dc-core-single-select", {
                                  attrs: {
                                    checked: _vm.form.data.warehouseFrom,
                                    options: _vm.warehouses,
                                    errors: _vm.form.options.errors,
                                    name: "warehouseFromId",
                                    "show-labels": false,
                                    "custom-label": _vm.translateListObj,
                                    title: _vm.trans(
                                      "warehouseman.prepare.search.warehouse_from"
                                    )
                                  },
                                  on: { dispatch: _vm.warehouseSelected },
                                  model: {
                                    value: _vm.form.data.warehouseFrom,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form.data,
                                        "warehouseFrom",
                                        $$v
                                      )
                                    },
                                    expression: "form.data.warehouseFrom"
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.areCheckedShifts
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "row form-group",
                                    staticStyle: { "margin-bottom": "5px" }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "col-md-3 control-label" },
                                      [
                                        _vm._v(
                                          "\n                                        " +
                                            _vm._s(
                                              _vm.trans(
                                                "warehouseman.move.search.warehouse_from"
                                              )
                                            ) +
                                            "\n                                    "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "col-md-9" }, [
                                      _vm.form.data.warehouseFrom
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.form.data.warehouseFrom.name
                                              )
                                            )
                                          ])
                                        : _vm._e()
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "row",
                        staticStyle: { "margin-bottom": "5px" }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "col-md-6" },
                          [
                            _vm.form.data.externalIssue
                              ? _c("dc-core-single-select", {
                                  attrs: {
                                    checked: _vm.form.data.supplier,
                                    options: _vm.suppliers,
                                    "show-labels": false,
                                    "custom-label": _vm.translateListObj,
                                    errors: _vm.form.options.errors,
                                    name: "supplierId",
                                    title: _vm.trans(
                                      "warehouseman.move.search.to_supplier"
                                    )
                                  },
                                  on: {
                                    dispatch: function($event) {
                                      return _vm.changeSupplierEvent($event)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.data.supplier,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form.data, "supplier", $$v)
                                    },
                                    expression: "form.data.supplier"
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    !_vm.form.data.externalIssue
                      ? _c(
                          "div",
                          {
                            staticClass: "row",
                            staticStyle: { "margin-bottom": "5px" }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "col-md-6" },
                              [
                                !_vm.areCheckedShifts
                                  ? _c("dc-core-single-select", {
                                      attrs: {
                                        checked: _vm.form.data.warehouseTo,
                                        options: _vm.warehouses,
                                        errors: _vm.form.options.errors,
                                        name: "warehouseToId",
                                        "show-labels": false,
                                        "custom-label": _vm.translateListObj,
                                        title: _vm.trans(
                                          "warehouseman.prepare.search.warehouse_to"
                                        )
                                      },
                                      model: {
                                        value: _vm.form.data.warehouseTo,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form.data,
                                            "warehouseTo",
                                            $$v
                                          )
                                        },
                                        expression: "form.data.warehouseTo"
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.areCheckedShifts
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "row form-group",
                                        staticStyle: { "margin-bottom": "5px" }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-md-3 control-label"
                                          },
                                          [
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(
                                                  _vm.trans(
                                                    "warehouseman.move.search.warehouse_to"
                                                  )
                                                ) +
                                                "\n                                    "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "col-md-9" }, [
                                          _vm.form.data.warehouseTo
                                            ? _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.form.data.warehouseTo
                                                      .name
                                                  )
                                                )
                                              ])
                                            : _vm._e()
                                        ])
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "row",
                        staticStyle: { "margin-bottom": "5px" }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "col-md-6" },
                          [
                            _c("dc-core-single-select", {
                              attrs: {
                                checked: _vm.form.data.deliver,
                                options: _vm.users,
                                errors: _vm.form.options.errors,
                                name: "deliverId",
                                "show-labels": false,
                                "custom-label": _vm.translateUserListObj,
                                title: _vm.trans(
                                  "warehouseman.move.search.deliver"
                                )
                              },
                              model: {
                                value: _vm.form.data.deliver,
                                callback: function($$v) {
                                  _vm.$set(_vm.form.data, "deliver", $$v)
                                },
                                expression: "form.data.deliver"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "row",
                        staticStyle: { "margin-bottom": "5px" }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "col-md-6" },
                          [
                            !_vm.form.data.externalIssue
                              ? _c("dc-core-single-select", {
                                  attrs: {
                                    checked: _vm.form.data.receiver,
                                    options: _vm.users,
                                    errors: _vm.form.options.errors,
                                    name: "receiverId",
                                    "show-labels": false,
                                    "custom-label": _vm.translateUserListObj,
                                    title: _vm.trans(
                                      "warehouseman.move.search.receiver"
                                    )
                                  },
                                  model: {
                                    value: _vm.form.data.receiver,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form.data, "receiver", $$v)
                                    },
                                    expression: "form.data.receiver"
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    !_vm.areCheckedShifts
                      ? _c(
                          "div",
                          {
                            staticClass: "row",
                            staticStyle: { "margin-bottom": "5px" }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "col-md-6" },
                              [
                                _c("checkbox", {
                                  attrs: {
                                    label: _vm.trans(
                                      "warehouseman.prepare.search.external_issue"
                                    )
                                  },
                                  model: {
                                    value: _vm.form.data.externalIssue,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form.data,
                                        "externalIssue",
                                        $$v
                                      )
                                    },
                                    expression: "form.data.externalIssue"
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "table",
                      {
                        staticClass: "table table-condensed",
                        staticStyle: { "margin-bottom": "0" }
                      },
                      [
                        _c("thead", [
                          _c("tr", [
                            _c("th", { staticStyle: { width: "270px" } }, [
                              _vm._v(
                                _vm._s(
                                  _vm.trans("warehouseman.move.table.material")
                                )
                              )
                            ]),
                            _vm._v(" "),
                            !_vm.form.data.externalIssue
                              ? _c("th", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.trans("warehouseman.move.table.meal")
                                    )
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("th", [
                              _vm._v(
                                _vm._s(
                                  _vm.trans("warehouseman.move.table.expected")
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("th", [
                              _vm._v(
                                _vm._s(
                                  _vm.trans("warehouseman.move.table.prepared")
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("th", [
                              _vm._v(
                                _vm._s(
                                  _vm.trans("warehouseman.move.table.final")
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("th", { staticStyle: { width: "110px" } }, [
                              _vm._v(
                                _vm._s(
                                  _vm.trans("warehouseman.move.table.execute")
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("th", [
                              _vm._v(
                                _vm._s(
                                  _vm.trans(
                                    "warehouseman.move.table.description"
                                  )
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("th", [
                              _vm._v(
                                _vm._s(
                                  _vm.trans(
                                    "warehouseman.move.table.material_release_receipt"
                                  )
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("th", { staticStyle: { width: "50px" } })
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          _vm._l(_vm.form.data.materials, function(
                            material,
                            i
                          ) {
                            return _c("tr", { key: i }, [
                              _c(
                                "td",
                                [
                                  !material.fromShift
                                    ? _c("simple-form-single-select", {
                                        key: _vm.key,
                                        ref: "sss",
                                        refInFor: true,
                                        attrs: {
                                          options: _vm.form.data.externalIssue
                                            ? _vm.materials
                                            : _vm.allMaterials,
                                          "show-labels": false,
                                          "custom-label": _vm.translateObject,
                                          "allow-empty": false
                                        },
                                        on: {
                                          dispatch: function($event) {
                                            return _vm.setProductsSelect(
                                              $event,
                                              i
                                            )
                                          }
                                        },
                                        model: {
                                          value: material.material,
                                          callback: function($$v) {
                                            _vm.$set(material, "material", $$v)
                                          },
                                          expression: "material.material"
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  material.fromShift
                                    ? _c("span", [
                                        _c("i", [_vm._v(_vm._s(material.name))])
                                      ])
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              !_vm.form.data.externalIssue
                                ? _c(
                                    "td",
                                    [
                                      !material.fromShift
                                        ? _c("simple-form-single-select", {
                                            attrs: {
                                              checked: material.mealId,
                                              options: _vm.meals,
                                              label: "nameForSelect"
                                            },
                                            on: {
                                              dispatch: function($event) {
                                                return _vm.mealSelected(
                                                  $event,
                                                  i
                                                )
                                              }
                                            },
                                            model: {
                                              value: material.mealId,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  material,
                                                  "mealId",
                                                  $$v
                                                )
                                              },
                                              expression: "material.mealId"
                                            }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      material.fromShift
                                        ? _c("span", [
                                            _c("i", [
                                              _vm._v(
                                                _vm._s(material.mealSelectName)
                                              )
                                            ])
                                          ])
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(material.amountExpected))
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    material.amountPrepared
                                      ? material.amountPrepared
                                      : 0
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    material.amountFinal
                                      ? material.amountFinal
                                      : 0
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: material.amountToMove,
                                      expression: "material.amountToMove"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: { type: "number" },
                                  domProps: { value: material.amountToMove },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        material,
                                        "amountToMove",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _c("textarea", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: material.description,
                                      expression: "material.description"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: { rows: "1", disabled: "disabled" },
                                  domProps: { value: material.description },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        material,
                                        "description",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: material.materialReleaseReceipt,
                                      expression:
                                        "material.materialReleaseReceipt"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: { type: "text" },
                                  domProps: {
                                    value: material.materialReleaseReceipt
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        material,
                                        "materialReleaseReceipt",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-danger btn-sm",
                                    attrs: {
                                      disabled:
                                        _vm.form.data.materials.length <= 1
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.remove(i)
                                      }
                                    }
                                  },
                                  [_c("span", { staticClass: "fa fa-minus" })]
                                )
                              ])
                            ])
                          }),
                          0
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm.form.options.errors.materials
                      ? _c("div", { staticClass: "has-error" }, [
                          _c("span", { staticClass: "help-block" }, [
                            _c("p", [
                              _vm._v(
                                _vm._s(
                                  _vm.trans(
                                    "warehouseman.common.table.fill_all_fields"
                                  )
                                )
                              )
                            ])
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-md-12" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary",
                            on: {
                              click: function($event) {
                                return _vm.add()
                              }
                            }
                          },
                          [
                            _c("i", { staticClass: "fa fa-plus" }),
                            _vm._v(
                              "\n                                    " +
                                _vm._s(
                                  _vm.trans(
                                    "warehouseman.common.table.add_position"
                                  )
                                ) +
                                "\n                                "
                            )
                          ]
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "modal-footer" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.print()
                          }
                        }
                      },
                      [
                        _c("i", { staticClass: "fa fa-print" }),
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.trans("warehouseman.common.print")) +
                            "\n                        "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-success spinner",
                        attrs: {
                          type: "button",
                          disabled: _vm.form.data.materials.length === 0,
                          "data-loading-text": _vm.loadingText
                        },
                        on: {
                          click: function($event) {
                            return _vm.execute()
                          }
                        }
                      },
                      [
                        _c("i", { staticClass: "fa fa-arrow-right" }),
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.trans("warehouseman.move.execute")) +
                            "\n                        "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm.areCheckedShifts
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-success spinner",
                            attrs: {
                              type: "button",
                              disabled: _vm.form.data.materials.length === 0,
                              "data-loading-text": _vm.loadingText
                            },
                            on: {
                              click: function($event) {
                                return _vm.execute(true)
                              }
                            }
                          },
                          [
                            _c("i", { staticClass: "fa fa-cart-arrow-down" }),
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.trans(
                                    "warehouseman.move.execute_and_close"
                                  )
                                ) +
                                "\n                        "
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-default",
                        attrs: { type: "button", "data-dismiss": "modal" },
                        on: {
                          click: function($event) {
                            return _vm.reset()
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.trans("warehouseman.common.close")) +
                            "\n                        "
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _vm.loading > 0
                    ? _c(
                        "div",
                        { staticClass: "loader" },
                        [
                          _c("h2", [
                            _vm._v(
                              _vm._s(_vm.trans("form.please_wait")) + "..."
                            )
                          ]),
                          _vm._v(" "),
                          _c("ring-loader")
                        ],
                        1
                      )
                    : _vm._e()
                ])
              ]
            )
          ]
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "print-block hide",
        attrs: { id: "print_move_materials", "data-name": "move" }
      },
      [
        _c("table", { staticClass: "table", staticStyle: { width: "50%" } }, [
          _c("tr", [
            _c("th", [
              _vm._v(
                _vm._s(_vm.trans("warehouseman.prepare.search.warehouse_from"))
              )
            ]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                _vm._s(
                  _vm.form.data.warehouseFrom
                    ? _vm.form.data.warehouseFrom.name
                    : "-"
                )
              )
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", [
              _vm._v(
                _vm._s(_vm.trans("warehouseman.prepare.search.warehouse_to"))
              )
            ]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                _vm._s(
                  _vm.form.data.warehouseTo
                    ? _vm.form.data.warehouseTo.name
                    : "-"
                )
              )
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", [
              _vm._v(_vm._s(_vm.trans("warehouseman.return.search.receiver")))
            ]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                _vm._s(
                  _vm.form.data.receiver ? _vm.form.data.receiver.username : "-"
                )
              )
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", [
              _vm._v(_vm._s(_vm.trans("warehouseman.return.search.deliver")))
            ]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                _vm._s(
                  _vm.form.data.deliver ? _vm.form.data.deliver.username : "-"
                )
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "table",
          {
            staticClass: "table",
            staticStyle: {
              "margin-top": "30px",
              width: "100%",
              "word-break": "break-all"
            }
          },
          [
            _c("thead", [
              _c("tr", [
                _c("th", [
                  _vm._v(_vm._s(_vm.trans("warehouseman.move.table.position")))
                ]),
                _vm._v(" "),
                _c("th", [
                  _vm._v(_vm._s(_vm.trans("warehouseman.move.table.product")))
                ]),
                _vm._v(" "),
                !_vm.form.data.externalIssue
                  ? _c("th", [
                      _vm._v(_vm._s(_vm.trans("warehouseman.move.table.meal")))
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("th", [
                  _vm._v(_vm._s(_vm.trans("warehouseman.move.table.expected")))
                ]),
                _vm._v(" "),
                _c("th", [
                  _vm._v(_vm._s(_vm.trans("warehouseman.move.table.prepared")))
                ]),
                _vm._v(" "),
                _c("th", [
                  _vm._v(_vm._s(_vm.trans("warehouseman.move.table.final")))
                ]),
                _vm._v(" "),
                _c("th", [
                  _vm._v(_vm._s(_vm.trans("warehouseman.move.table.execute")))
                ]),
                _vm._v(" "),
                _c("th", [
                  _vm._v(
                    _vm._s(_vm.trans("warehouseman.move.table.description"))
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "tbody",
              _vm._l(_vm.form.data.materials, function(material, i) {
                return _c("tr", { key: i }, [
                  _c("td", [
                    _vm._v(
                      _vm._s(material.material ? material.material.name : "")
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      _vm._s(material.product ? material.product.name : "")
                    )
                  ]),
                  _vm._v(" "),
                  !_vm.form.data.externalIssue
                    ? _c("td", [_vm._v(_vm._s(material.mealSelectName))])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      _vm._s(
                        material.amountExpected ? material.amountExpected : 0
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      _vm._s(
                        material.amountPrepared ? material.amountPrepared : 0
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      _vm._s(material.amountFinal ? material.amountFinal : 0)
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(material.amountToMove))]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(material.description))])
                ])
              }),
              0
            )
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-12cd15ad", { render: render, staticRenderFns: staticRenderFns })
  }
}